module.exports = __webpack_public_path__ + "img/2016-3.dde62e46.jpg";